import { useMemo } from "react";

import type { InfiniteData } from "@tanstack/react-query";

import type { PaginatedResponse } from "../types";

export const useFlattenedInfinityData = <T>(
  data: InfiniteData<PaginatedResponse<T>> | undefined,
) => {
  return useMemo(() => {
    const allItems = data?.pages.flatMap((page) => page.data) ?? [];
    const total = data?.pages[0].total ?? 0;

    return {
      data: allItems,
      total,
    };
  }, [data]);
};
